import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { StatusMotorista } from 'src/app/models/status-motorista.model';
import { AlertService } from 'src/app/services/alert.service';
import { PreCheckoutService } from 'src/app/services/pre-checkout.service';
import { TranslateConfigService } from 'src/app/services/translate-config.service';
import { Utilitarios } from 'src/app/shared/utilitarios';
import { PreCheckoutQuery } from 'src/app/state/pre-checkout.query';
import { DisplayLoginComponents, PreCheckoutLoginService } from '../pre-checkout-login.service';

@Component({
  selector: 'app-pre-checkout-login-info',
  templateUrl: './pre-checkout-login-info.component.html',
  styleUrls: ['./pre-checkout-login-info.component.css']
})
export class PreCheckoutLoginInfoComponent implements OnInit {

  translation: any;
  tentativa: number = 0;
  questionSelected: any = {};
  @Input() statusMotorista: StatusMotorista = new StatusMotorista();
  usuarioBloqueado: boolean = false;
  randomNumber: number = null;
  preCheckoutFormInfo = this.formBuilder.group({
    info: ''
  });

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private preCheckoutQuery: PreCheckoutQuery,
    private preCheckoutService: PreCheckoutService,
    private translateConfigService: TranslateConfigService,
    private translate: TranslateService,
    private loginService: PreCheckoutLoginService
  ) { }

  validInfo() {
    return this.preCheckoutFormInfo.value.info?.length > 0;
  }

  validFormInfo() {
    return this.preCheckoutFormInfo.valid;
  }

  internalError(err){
    this.alertService.alertDanger(this.translation.internalError, null);
  }

  nextRandomNumber(): number{
    let number = Math.floor(Math.random() * 6) + 1;

    if(this.randomNumber!=null && this.randomNumber==number)
      this.nextRandomNumber();
    else
      this.randomNumber = number;

    return number;
  }

  generateQuestions(){

    var questionNumber = this.nextRandomNumber();

    let diaNascimento = new Date(this.statusMotorista?.detalhes?.data_nascimento).getDate();
    let mesNascimento = new Date(this.statusMotorista?.detalhes?.data_nascimento).getMonth() + 1;
    let anoNascimento = new Date(this.statusMotorista?.detalhes?.data_nascimento).getFullYear();

    let questions = [
      {pergunta:"Qual o dia do seu aniversário?",resposta:diaNascimento?.toString().padStart(2, '0'), placeHolder:"Informe 2 digitos para o dia", mask:"00"},
      {pergunta:"Qual o mês do seu aniversário?",resposta:mesNascimento?.toString().padStart(2, '0'), placeHolder:"Informe 2 digitos para o mês", mask:"00"},
      {pergunta:"Qual o ano do seu aniversário?",resposta:anoNascimento, placeHolder:"Informe 4 digitos para o ano", mask:"0000"},
      {pergunta:"Qual o primeiro nome da sua mãe?",resposta:this.statusMotorista?.detalhes?.nome_mae?.split(" ")[0], placeHolder:"", mask:""},
      {pergunta:"Qual o primeiro nome do seu pai?",resposta:this.statusMotorista?.detalhes?.nome_pai?.split(" ")[0], placeHolder:"", mask:""},
      {pergunta:"Qual é o número da CNH?",resposta:this.statusMotorista?.detalhes?.cnh, placeHolder:"", mask:""},
      {pergunta:"Informe os 4 primeiros digitos do seu RG?",resposta:this.statusMotorista?.detalhes?.rg?.substring(0,4), placeHolder:"", mask:"0000"},
      //{pergunta:"Qual é o Estado (UF) de nascimento?",resposta:"BAHIA"},
      //{pergunta:"Qual é a cidade de nascimento?",resposta:"SALVADOR"}
    ]

    this.questionSelected = questions[questionNumber];
  }

  tentativasLimiteBloqueio(callBack: any)
  {
    this.tentativa = Utilitarios.tentativasLimiteBloqueio(this.tentativa, callBack);
  }

  bloquearMotorista(){
    this.preCheckoutQuery.cpf$.subscribe((cpf)=>{
      this.preCheckoutService.bloquearMotorista(cpf)
        .subscribe(
          (result) => {
            let message = "Você excedeu o limite máximo de 3 tentativas!\n";
            message+="Pré-checkout reprovado!";
            this.alertService.alertWarning(message,null);
          },
          (err) => {
            this.internalError(err);
          }
        );
    });
  }

  onSubmit(): void {
    if (this.validFormInfo){
      if(
          Utilitarios.substituirCaracteresEspeciais(this.preCheckoutFormInfo.value.info)?.trim().toLowerCase()!=Utilitarios.substituirCaracteresEspeciais(this.questionSelected.resposta?.toString())?.trim().toLowerCase()
        ){
        this.alertService.alertWarning("Resposta não confere com a cadastrada no sistema Teleconsult, tente novamente!", null);
        this.generateQuestions();
        this.preCheckoutFormInfo.reset();
        this.tentativasLimiteBloqueio(function(){
          this.bloquearMotorista();
          this.usuarioBloqueado = true;
        }.bind(this));
      }
      else{
        this.alertService.alertSuccess("Informação cadastral validada com sucesso!", null);
        this.loginService.setDisplay(new DisplayLoginComponents(false, false, false));
      }
    }
  }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();
    
    this.translate.get("preCheckout").subscribe((res) => {
      this.translation = res;
    });
    
    this.generateQuestions();
  }

}
